export default __webpack_public_path__ + "static/media/great_recruiter.39136762.png";